<!-- 查看详情 -->
<template>
  <div class="info" v-loading="loading">
    <back />

    <el-form :model="ruleForm" ref="ruleForm" label-width="155px" class="demo-ruleForm">
      <div class="form">

        <!-- 基本信息 -->
        <div class="container">
          <div class="item">课程名称：{{ ruleForm?.courseName }}</div>
          <div class="item">课程分类：{{ ruleForm?.categoryName }}</div>
          <div class="item">课程专家：{{ ruleForm?.teacherName }}</div>
          <div class="item">是否收费:
            <span v-if="ruleForm?.costAttr == 0">否</span>
            <span v-if="ruleForm?.costAttr == 1">是</span>
          </div>
          <div class="item">课程价格(元)：{{ ruleForm?.costAttr == 0 ? '免费' : ruleForm?.price }}</div>
          <div class="item" v-if="ruleForm?.effectiveDay">购买后有效天数:{{ ruleForm?.effectiveDay }}</div>
          <div class="item">是否推荐:
            <span v-if="ruleForm?.recommendFlag == 0">否</span>
            <span v-if="ruleForm?.recommendFlag == 1">是</span>
          </div>
          <div class="item pic">
            <span class="text">课程封面:</span>
            <el-image style="width: 100px; height: 100px" :src='ruleForm?.coursePic' fit="fill"
              :preview-src-list="[ruleForm?.coursePic]"></el-image>
          </div>
        </div>
        <div class="container">
          <div class="item">课程简介：<div v-html="ruleForm?.introduce"></div>
          </div>
        </div>


      </div>

    </el-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      ruleForm: {

      },
    }
  },
  created() {
    this.selectCourseInfoDetail();
  },
  methods: {
    selectCourseInfoDetail() {
      this.loading = true;
      this.$axios.get(this.$api.selectCourseInfoDetail, {
        params: {
          id: this.$route.query.id,
        }
      }).then((res) => {
        if (res.code == 100) {
          this.ruleForm = res.result
          const regex = new RegExp('<img', 'gi')
          if (this.ruleForm.introduce) {
            this.ruleForm.introduce = res.result.introduce.replace(regex, `<img style="max-width: 100%; height: auto;"`);
          }
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.info {
  .form {
    margin: 30px 20px;

    .container {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 30px;
      font-size: 16px;
      color: #707070;
    }

    .item {
      width: 32%;
      /* 100% / 3 = 33.33%，留一点空间避免浏览器计算误差 */
      margin-bottom: 30px;
    }

    .container .item:nth-last-child(-n+3) {
      margin-bottom: 0;
    }

    ::v-deep .el-checkbox__label,
    ::v-deep .el-radio__label {
      color: #707070;
      font-size: 16px;
    }
  }

  .pic {
    display: flex;

    .text {
      margin-right: 15px;
    }
  }
}
</style>
